import { researchStatus } from '@/enums/researchStatus'
export enum ContentType {
  EXCLUSIVE = 'exclusive',
  FREE = 'free'
}
export interface iCommunityResearch {
  id: number
  article_title: string
  thumbnail: string | null
  article_category_id: number
  first_summary: string
  second_summary: string
  third_summary: string
  short_description: string
  first_content: string
  second_content: string
  status: researchStatus
  writter_id: number
  auditor_id: number
  article_slug: string
  created_at: Date
  published_at: Date
  updated_at: Date | null
  deleted_at: Date | null
  category: {
    id: string
    article_category_name: string
    deleted_at: Date | null
  } | null
  writter: {
    id: number
    fullname: string
    email: string
    thumbnail: string
  }
  content_type: ContentType
}
